var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01LideresIndivSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.63 18.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M424.28,251.85l-2-4.61a7.07,7.07,0,0,0,1.46-4.33,7.18,7.18,0,1,0-14.36,0,7.12,7.12,0,0,0,1.45,4.33l-2,4.61a.61.61,0,0,0,.11.67.63.63,0,0,0,.66.17l2.27-.77.95,2.2a.62.62,0,0,0,.57.38.63.63,0,0,0,.57-.37l1.8-4.09a6.51,6.51,0,0,0,1.65,0l1.8,4.09a.64.64,0,0,0,.58.37.63.63,0,0,0,.57-.38l.95-2.2,2.27.77a.63.63,0,0,0,.66-.17A.61.61,0,0,0,424.28,251.85Zm-2.95-3.61,1.24,2.82-1.48-.5a.62.62,0,0,0-.77.34l-.61,1.42-1.12-2.53A7.32,7.32,0,0,0,421.33,248.24Zm-6.88,1.55-1.12,2.53-.61-1.42a.64.64,0,0,0-.58-.38.43.43,0,0,0-.19,0l-1.48.5,1.24-2.82A7.32,7.32,0,0,0,414.45,249.79Zm8-6.88a5.94,5.94,0,1,1-5.94-6A6,6,0,0,1,422.46,242.91Z",
    transform: "translate(-408.71 -235.69)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M419.73,241.28,417.9,241l-.82-1.66a.63.63,0,0,0-1.12,0l-.82,1.66-1.83.27a.62.62,0,0,0-.5.42.59.59,0,0,0,.16.64l1.32,1.29-.31,1.83a.61.61,0,0,0,.25.6.59.59,0,0,0,.65.05l1.64-.86,1.64.86a.59.59,0,0,0,.29.07.6.6,0,0,0,.36-.12.61.61,0,0,0,.25-.6l-.31-1.83,1.32-1.29a.63.63,0,0,0,.16-.64A.62.62,0,0,0,419.73,241.28Zm-2.26,2.24.15.91-.81-.43a.6.6,0,0,0-.58,0l-.81.43.15-.91a.6.6,0,0,0-.18-.55l-.65-.64.9-.13a.62.62,0,0,0,.47-.34l.41-.83.41.83a.62.62,0,0,0,.46.34l.91.13-.66.64A.62.62,0,0,0,417.47,243.52Z",
    transform: "translate(-408.71 -235.69)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01LideresIndivSelect);
export default __webpack_public_path__ + "static/media/01_LideresIndiv_Select.6dc3a271146deba6415e23118236cf01.svg";
export { ForwardRef as ReactComponent };